(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/spelpaus/assets/javascripts/models/suspensionoverview.js') >= 0) return;  svs.modules.push('/modules/spelpaus/assets/javascripts/models/suspensionoverview.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.spelpaus.models.SuspensionOverview = Backbone.Model.extend({
    defaults: {
      type: undefined,
      period: undefined,
      suspensionHistory: undefined,
      activeSuspensions: undefined
    },
    parse: function(response) {
      return _.extend({}, response, {
        suspensionHistory: new svs.spelpaus.collections.SuspensionHistory(response.suspensionHistory),
        activeSuspensions: new svs.spelpaus.collections.Suspensions(response.activeSuspensions)
      });
    }
  });
})(Backbone, _, svs);

 })(window);